<template>
    <div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div class="bg-white rounded-lg p-6 max-w-md w-full mx-4">
        <div class="flex flex-col items-center">
          <!-- Success Icon -->
          <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100 mb-4">
            <svg class="h-6 w-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
            </svg>
          </div>
  
          <!-- Message Content -->
          <div class="text-center">
            <h3 class="text-lg leading-6 font-medium text-gray-900">
              Pembayaran Berhasil
            </h3>
            <div class="mt-2">
              <p class="text-sm text-gray-500">
                Pesanan Anda akan segera diproses setelah pembayaran dikonfirmasi oleh admin.
              </p>
            </div>
          </div>
  
          <!-- Button -->
          <div class="mt-5 w-full">
            <button
              @click="$emit('close')"
              class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-green-600 text-base font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 sm:text-sm"
            >
              Tutup
            </button>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'SuccessModal',
    emits: ['close']
  }
  </script>